import { createAsyncThunk } from '@reduxjs/toolkit';
import { useCustomAxios } from '../../shared/lib/customAxios';
import { API_ENDPOINTS } from '../../shared/constants/constants';

export const addPartyApi = createAsyncThunk(
    'party/addParty',
    async (reqBody:any)=> {
        const { axiosPost } = useCustomAxios();
        try {
            const response = await axiosPost(`${API_ENDPOINTS.addParty}`, reqBody);
            return { data: response.data, status: response.status };
          } catch (error: any) {
            return {
              error: error.response.data.message,
              status: error.response.status,
            };
          }
    }
)

export const createOrganizationMemberApi = createAsyncThunk(
    'party/createMember',
    async (reqBody:any)=> {
        const { axiosPost } = useCustomAxios();
        try {
            const response = await axiosPost(`${API_ENDPOINTS.createMember}`, reqBody);
            return { data: response.data, status: response.status };
          } catch (error: any) {
            return {
              error: error.response.data.message || error.response.data.error,
              status: error.response.status,
            };
          }
    }
)
